import React, { Component} from "react";
import { withRouter } from "react-router-dom";
import axios from "axios";
import {Footer, Header, LastSection} from "../components";
import { FAQ_SHOW_ALL_URL } from "../constants/path";

class FaqPage extends Component{
	constructor(props) {
		super(props);
		this.state = {
			content: ''
		}
	}
	componentDidMount() {
		const id = this.props.location.pathname.split('/')[2];
		window.scrollTo(0,0);
		if(this.props.location.state !== undefined) {
			let content = <div className="row faqpage-container">
				<h1 className="pb-4 text-right faq-page-title pl-0">
					{ this.props.location.state.question }
				</h1>
				<div className="col-12 text-right faq-detail text-justify" dangerouslySetInnerHTML={{__html: this.props.location.state.answer}}/>
			</div>;
			this.setState( {content: content} );
		} else {
			axios.get(FAQ_SHOW_ALL_URL)
				.then(resulte => {
					// return resulte.json();
					return resulte.data;
				}).then(data => {
				let content = data.faq.map((items) => {
					for(let key in items.questions) {
						if(items.questions[key].id === parseInt(id)) {
							return (
								<div className="row faqpage-container" key={items.questions[key].id}>
									<h1 className="pb-4 text-right faq-page-title pl-0">
										{ items.questions[key].question }
									</h1>
									<div className="col-12 text-right faq-detail text-justify" dangerouslySetInnerHTML={{__html: items.questions[key].answer}}/>
								</div>
							);
						} else {
							continue;
						}
					}
					return true;
				});
				this.setState( {content: content} );
			});
		}
	}
	render () {
		return(
			<div>
				<Header />
				<div className="container direction-rtl mb-5">
					{this.state.content}
				</div>
				{/* <FAQ title="مقالات مرتبط" subPageStyle={true} clsName="faq-main-page-text-color" /> */}
				<LastSection/>
				<Footer />
			</div>
		);
	}
}

export default withRouter(FaqPage);